__turbopack_context__.v({
  "ProductLegacyCard": "_8KewWW_ProductLegacyCard",
  "ProductLegacyCard__Button": "_8KewWW_ProductLegacyCard__Button",
  "ProductLegacyCard__ButtonText": "_8KewWW_ProductLegacyCard__ButtonText",
  "ProductLegacyCard__Container": "_8KewWW_ProductLegacyCard__Container",
  "ProductLegacyCard__Description": "_8KewWW_ProductLegacyCard__Description",
  "ProductLegacyCard__LogoImageWrapper": "_8KewWW_ProductLegacyCard__LogoImageWrapper",
  "ProductLegacyCard__ProductImageWrapper": "_8KewWW_ProductLegacyCard__ProductImageWrapper",
});
